import { Fragment } from "react";

const CardFrame = (props) => {
  return (
    <Fragment>
      <div>{props.children}</div>
    </Fragment>
  );
};

export default CardFrame;
